import { useTheme } from '../lib/theme'
import { cn } from '../lib/cn'

/**
 * Переключатель темы.
 *
 * Вынесен из шапки отдельным компонентом, потому что нужен ещё и до входа: экраны
 * почты и кода живут без каркаса приложения, а человек, у которого тёмная тема
 * стоит в системе, впервые видит систему именно на них. Тумблер, доступный только
 * после входа, — это тумблер, о котором не знают.
 *
 * Иконка и подпись одни на оба места: две копии одной кнопки разъезжаются
 * в формулировках раньше, чем в поведении.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggle } = useTheme()

  return (
    <button
      type="button"
      onClick={toggle}
      title={theme === 'dark' ? 'Светлая тема' : 'Тёмная тема'}
      aria-label={theme === 'dark' ? 'Включить светлую тему' : 'Включить тёмную тему'}
      className={cn(
        'grid h-9 w-9 shrink-0 place-items-center rounded-lg border border-line text-muted transition hover:text-fg',
        className,
      )}
    >
      <span aria-hidden>{theme === 'dark' ? '☾' : '☀'}</span>
    </button>
  )
}
